module.exports = __webpack_public_path__ + "img/225.c0f9498f.jpg";